/**
 * How a provision event of a contract is determined (04-frontend.md §2.6, A4-03) — deliberately
 * closed to exactly two ways. CONTRACT_START fires at the start of the contract and always wins
 * over a price change on the same day (A4-05); CONTRACT_PRICE_CHANGE fires on a price time slice
 * whose price reason is configured for the event (K-16).
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionEventDeterminationType}.
 * The backend persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order
 * below MUST match the backend exactly and new constants MUST only be appended at the end — never
 * inserted between existing ones, which would silently re-map every stored value
 * (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionEventDeterminationType {

    CONTRACT_START,
    CONTRACT_PRICE_CHANGE
}
